import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="random-password"
export default class extends Controller {
  static targets = ['passwordField']
  static values = { passwordLength: Number }

  initialize() {
    this.lowerStr = 'abcdefghijklmnopqrstuvwxyz'
    this.upperStr = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'
    this.numberStr = '0123456789'

    var allLength = this.numberStr.length + this.lowerStr.length + this.upperStr.length
    this.numberLength = Math.round(this.passwordLengthValue / allLength * this.numberStr.length)
    this.upperLength = Math.round(this.passwordLengthValue / allLength * this.upperStr.length)
  }

  generate(event) {
    event.preventDefault()

    let passwordChars = [];
    for (let i = 0; i < this.passwordLengthValue; i++) {
      let str
      if (i < this.numberLength) {
        str = this.numberStr
      } else if (i < this.upperLength) {
        str = this.upperStr
      } else {
        str = this.lowerStr
      }
      passwordChars.push(str.charAt(Math.floor(Math.random() * str.length)))
    }
    this.passwordFieldTarget.value = this.shuffle(passwordChars).join('')
  }

  shuffle(chars) {
    for (let i = chars.length - 1; i >= 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [chars[i], chars[j]] = [chars[j], chars[i]];
    }
    return chars;
  }
}
